import { useSetRecoilState } from 'recoil';
import { actionBarAtom } from 'common/actionBar/stores/atom';
import { ActionBarInputs } from 'common/actionBar/types/actionBar';

export const useActionBar = () => {
  const setActionBar = useSetRecoilState(actionBarAtom);

  const openActionBar = (inputs: ActionBarInputs) => {
    setActionBar({
      isOpen: true,
      inputs
    });
  };

  const closeActionBar = () => {
    setActionBar({
      isOpen: false,
      inputs: null
    });
  };

  return {
    openActionBar,
    closeActionBar
  };
};
